import { render } from "./JLAlert.vue?vue&type=template&id=649f090f&scoped=true"
import script from "./JLAlert.vue?vue&type=script&lang=js"
export * from "./JLAlert.vue?vue&type=script&lang=js"

import "./JLAlert.vue?vue&type=style&index=0&id=649f090f&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ardent_dms_v2\\ardent_dms\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-649f090f"]])

export default __exports__